import { AxiosResponse } from 'axios';
import { axiosInstance } from '../';

export function postUserSupplierAdherence(id: number, moduleId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`UserSupplierAdherence/`, {
    userId: id,
    moduleId: moduleId
  }, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUserAdherence(supplierIds?: number[], categories?: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`UserSupplierAdherence/monthly-summary`, {
    params: {
      supplierIds: supplierIds?.join(','),
      categories,
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export async function exportExcelAdherence(): Promise<void> {
  try {
    const response = await axiosInstance.get('UserSupplierAdherence/ExportExcelAdherence', {
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });

    const blob = new Blob([response.data], { type: response.headers['content-type'] });

    const contentDisp = response.headers['content-disposition'] || response.headers['Content-Disposition'] || null;
    let fileName = getFileNameFromContentDisposition(contentDisp);

    if (!fileName) {
      fileName = `Frecuencia_de_adherencia_${new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')}.xlsx`;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('❌ Error al exportar Excel de adherencia:', error);
    alert('Ocurrió un error al generar el Excel de adherencia.');
  }
}

function getFileNameFromContentDisposition(contentDisposition?: string | null): string | null {
  if (!contentDisposition) return null;

  const cd = String(contentDisposition);

  const filenameStarMatch = cd.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    try {
      let raw = filenameStarMatch[1].trim().replace(/^"(.*)"$/, '$1');
      return decodeURIComponent(raw);
    } catch {
      return filenameStarMatch[1].trim().replace(/^"(.*)"$/, '$1');
    }
  }

  const filenameMatch = cd.match(/filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i);
  if (filenameMatch) {
    const name = (filenameMatch[1] || filenameMatch[2] || '').trim();
    return name.replace(/^"(.*)"$/, '$1');
  }

  return null;
}